export const activity = {
  activityWebEmptyStateTitle: 'Dar nėra jokios veiklos',
  activityWebEmptyStateText: 'Čia bus rodomas jūsų pranešimų srautas',
  activitySeeAll: 'Rodyti viską',
  in: 'viduje'
}
